(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantDetailController', ServiceTimeSessionServantDetailController);

    ServiceTimeSessionServantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceTimeSessionServant', 'ServiceTimeSession', 'Servant'];

    function ServiceTimeSessionServantDetailController($scope, $rootScope, $stateParams, entity, ServiceTimeSessionServant, ServiceTimeSession, Servant) {
        var vm = this;

        vm.serviceTimeSessionServant = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceTimeSessionServantUpdate', function (event, result) {
            vm.serviceTimeSessionServant = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
